<!-- Modal Header - matching original AngularJS style: background #cd5763 -->
<div class="modal-header" style="background-color: #cd5763;">
  <h3 class="modal-title">
    Edit Comment for <b>{{ parentMeName }}</b>
  </h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div>
    <label>Edit Business sign Off Comment:</label>
    <textarea class="form-control" required [(ngModel)]="desc"></textarea>
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
